import BaseTag from "./BaseTag";

const RestTag = (props) => <BaseTag label={props.value} />;

export default RestTag;
